import axiosInstance from '../../../axiosConfig';

export interface UnsubscribeResponse {
  channel: 'EMAIL' | 'SMS';
}

export const postUnsubscribe = async (
  token: string,
): Promise<UnsubscribeResponse> => {
  const { data } = await axiosInstance.post<UnsubscribeResponse>(
    '/api/outreach/unsubscribe',
    { token },
  );
  return data;
};
